import React from 'react'
import { Link } from 'gatsby'
import ReactWOW from 'react-wow'
import Carousel from 'react-elastic-carousel'
import Item from './Item';
import clustersHomeImg from '../../assets/images/features-home/clusters.webp'
import instantPushHomeImg from '../../assets/images/features-home/instant-push.webp'
import laterBoardHomeImg from '../../assets/images/features-home/later-board.webp'
import unifiedFoldersHomeImg from '../../assets/images/features-home/unified-folders.webp'
import seeAllArrowHomeImg from '../../assets/images/features-home/see-all-arrow.svg'

import integratedCalendarHomeImg from '../../assets/images/features-home/integrated-calendar.webp'

import richTextHomeImg from '../../assets/images/features-home/rich-text.webp'

import magicSyncHomeImg from '../../assets/images/features-home/magic-sync.webp'

import spanManagementHomeImg from '../../assets/images/features-home/span-management.webp'


const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2 },
    { width: 768, itemsToShow: 3 },
    { width: 1200, itemsToShow: 4 },
];

const Features = () => {
    return (
        <div className='container-fluid features-carousel'>
          <h1><span>Powerful</span> And <span>Intuitive</span></h1>
          <div className="App">
            <Carousel breakPoints={breakPoints}>
            <Link to='/features-functions/clusters/'>
              <Item className='card'>
                <ReactWOW delay='.1s' animation='fadeInUp'>
                  <div className='row'>
                      <div className='col'>
                          <img className='box-image' src={clustersHomeImg} alt="features home"/>
                      </div>
                  </div>
                </ReactWOW>
                <div className='row'>
                  <div className='box-content one'>
                    <div className='col'>
                      <h4>Clusters</h4>
                    </div>                  
                    <div className='row'>
                      <div className='col'>
                        <p>Dynamically organize your Inbox by sender & group,  bringing together emails from People, Groups, 
                          and Services to declutter your mailbox.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Item>
              </Link>
              <Link to='/features-functions/instant-push/'>
              <Item className='card'>
                <ReactWOW delay='.1s' animation='fadeInUp'>
                  <div className='row'>
                      <div className='col'>
                          <img className='box-image' src={instantPushHomeImg} alt="Instant Push"/>
                      </div>
                  </div>
                </ReactWOW>
                <div className='row'>
                  <div className='box-content two'>
                    <div className='col'>
                      <h4>Instant Push</h4>
                    </div>                  
                    <div className='row'>
                      <div className='col'>
                        <p>BlueMail intelligently pushes your emails directly to your device, so 
                          they arrive at your Inbox instantaneously, saving you valuable time.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Item>
              </Link>
              <Link to='/features-functions/get-stuff-done/'>
              <Item className='card'>
                <ReactWOW delay='.1s' animation='fadeInUp'>
                  <div className='row'>
                      <div className='col'>
                          <img className='box-image' src={laterBoardHomeImg} alt="Later Board"/>
                      </div>
                  </div>
                </ReactWOW>
                <div className='row'>
                  <div className='box-content three'>
                    <div className='col'>
                      <h4>Later Board</h4>
                    </div>                  
                    <div className='row'>
                      <div className='col'>
                        <p>Stay on top of your mailbox with a task board for your emails. Mark emails to 
                          “Read” or “Reply Later,” and Get Stuff Done at your convenience. 
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Item>
              </Link>
              <Link to='/features-functions/unified-inbox/'>
              <Item className='card'>
                <ReactWOW delay='.1s' animation='fadeInUp'>
                  <div className='row'>
                      <div className='col'>
                          <img className='box-image' src={unifiedFoldersHomeImg} alt="Unified Folders"/>
                      </div>
                  </div>
                </ReactWOW>
                <div className='row'>
                  <div className='box-content four'>
                    <div className='col'>
                      <h4>Unified Folders</h4>
                    </div>                  
                    <div className='row'>
                      <div className='col'>
                        <p>Emails from all your accounts are combined and displayed in unique folders so you can view 
                          and perform actions on multiple accounts at the same time.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Item>
              </Link>
              <Link to='/calendar/'>
              <Item className='card'>
                <ReactWOW delay='.1s' animation='fadeInUp'>
                  <div className='row'>
                      <div className='col'>
                          <img className='box-image' src={integratedCalendarHomeImg} alt="Integrated Calendar"/>
                      </div>
                  </div>
                </ReactWOW>
                <div className='row'>
                  <div className='box-content five'>
                    <div className='col'>
                      <h4>Integrated Calendar</h4>
                    </div>                  
                    <div className='row'>
                      <div className='col'>
                        <p>BlueMail Calendar allows to plan events, invite contacts, and set notifications. BlueMail calendar is synchronized with Exchange ActiveSync and CalDAV accounts.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Item>
              </Link>
              <Item className='card'>
                <ReactWOW delay='.1s' animation='fadeInUp'>
                  <div className='row'>
                      <div className='col'>
                          <img className='box-image' src={richTextHomeImg} alt="Rich Text Signature"/>
                      </div>
                  </div>
                </ReactWOW>
                <div className='row'>
                  <div className='box-content six'>
                    <div className='col'>
                      <h4>Rich Text Signature</h4>
                    </div>                  
                    <div className='row'>
                      <div className='col'>
                        <p>Stay on top of your mailbox with a task board for your emails. Mark emails to “Read” or “Reply Later,” 
                          and Get Stuff Done at your convenience.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Item>
              <Link to='/blog/magicsync-settings-sync/'>
              <Item className='card'>
                <ReactWOW delay='.1s' animation='fadeInUp'>
                  <div className='row'>
                      <div className='col'>
                          <img className='box-image' src={magicSyncHomeImg} alt="MagicSync"/>
                      </div>
                  </div>
                </ReactWOW>
                <div className='row'>
                  <div className='box-content seven'>
                    <div className='col'>
                      <h4>MagicSync</h4>
                    </div>                  
                    <div className='row'>
                      <div className='col'>
                        <p>Dynamically organize your Inbox by sender & group,  bringing together emails from People, Groups, 
                          and Services to declutter your mailbox.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Item>
              </Link>
              <Link to='/security/block-list/'>
              <Item className='card'>
                <ReactWOW delay='.1s' animation='fadeInUp'>
                  <div className='row'>
                      <div className='col'>
                          <img className='box-image' src={spanManagementHomeImg} alt="Spam Management"/>
                      </div>
                  </div>
                </ReactWOW>
                <div className='row'>
                  <div className='box-content eight'>
                    <div className='col'>
                      <h4>Spam Management</h4>
                    </div>                  
                    <div className='row'>
                      <div className='col'>
                        <p>Emails from all your accounts are combined and displayed in unique folders so you can view and 
                          perform actions on multiple accounts at the same time.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Item>
              </Link>
            </Carousel>
          </div>
          <Link className='see-all' to='/features-functions/'>
            <h3>See feature highlights 
              <img src={seeAllArrowHomeImg} alt="See all image"/>
            </h3>
          </Link>
        </div>
    )
}

export default Features;
